import { createRouter, createWebHistory } from 'vue-router';
import SideBar from '@/Vue/common/SideBar/SideBar';
import store from '@/store/index';
import { vueRoutes } from '@/router/route-const';
const routes = [
  {
    path: '/',
    name: 'MainPage',
    redirect: '/dashboard',
  },

  {
    path: '/login',
    name: vueRoutes.login.name,
    components: {
      default: () => import('@/Vue/components/Authorization/Login.vue'),
    },
    meta: {
      requiredVisitor: true,
    },
  },
  {
    path: '/users',
    name: vueRoutes.users.name,
    components: {
      default: () => import('../Vue/components/Users/Users'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/users/notaries',
    name: vueRoutes.notaries.name,
    components: {
      default: () => import('../Vue/components/Users/Users'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/notary-requests',
    name: vueRoutes.notaryRequests.name,
    components: {
      default: () => import('../Vue/components/Notary/NotaryRequests'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/rentals-admin',
    name: vueRoutes.rentalsAdmin.name,
    components: {
      default: () => import('../Vue/components/Rentals/RentalsAdmin.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    // top-up invoices: confirm bank transfers, the platform's bank accounts (2026-10-25)
    path: '/topup-invoices',
    name: vueRoutes.topupAdmin.name,
    components: {
      default: () => import('../Vue/components/Topup/TopupAdmin.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/wallet-recovery',
    name: vueRoutes.walletRecovery.name,
    components: {
      default: () => import('../Vue/components/WalletRecovery/WalletRecovery'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/users/:id',
    name: vueRoutes.usersDetails.name,
    components: {
      default: () => import('../Vue/components/Users/UsersDetails'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/real-estate',
    name: vueRoutes.realEstate.name,
    components: {
      default: () => import('../Vue/components/RealEstate/RealEstateTokens'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: '/real-estate/commissionedRE/active', // Редирект на начальное состояние
    children: [
      {
        path: 'commissionedRE/:state',
        name: vueRoutes.commissionedRE.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
        // props: (route) => ({
        //   state: route.params.state, // Передаем параметр состояния в компонент
        // }),
      },
      {
        path: 'uncommissionedRE/:state',
        name: vueRoutes.uncommissionedRE.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
        // props: (route) => ({
        //   state: route.params.state, // Передаем параметр состояния в компонент
        // }),
      },
    ],
  },
  // {
  //   path: '/real-estate',
  //   name: vueRoutes.realEstate.name,
  //   components: {
  //     default: () => import('../Vue/components/RealEstate/RealEstateTokens'),
  //     SideBar,
  //   },
  //   meta: {
  //     requiredAuth: true,
  //   },
  //   redirect: '/real-estate/commissionedRE-active',
  //   children: [
  //     {
  //       path: 'commissionedRE-active',
  //       name: vueRoutes.commissionedREactive.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //     {
  //       path: 'commissionedRE-archived',
  //       name: vueRoutes.commissionedREarchived.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //     {
  //       path: 'commissionedRE-on-balance',
  //       name: vueRoutes.commissionedREbalance.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //     {
  //       path: 'uncommissionedRE-active',
  //       name: vueRoutes.uncommissionedREactive.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //     {
  //       path: 'uncommissionedRE-archived',
  //       name: vueRoutes.uncommissionedREarchived.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //     {
  //       path: 'uncommissionedRE-on-balance',
  //       name: vueRoutes.uncommissionedREbalance.name,
  //       components: {
  //         default: () =>
  //           import('../Vue/components/RealEstate/RealEstateTokens'),
  //         SideBar,
  //       },
  //       meta: {
  //         requiredAuth: true,
  //       },
  //     },
  //   ],
  // },
  {
    path: '/real-estate/:id',
    name: vueRoutes.realEstateDetails.name,
    components: {
      default: () => import('../Vue/components/RealEstate/RealEstateDetails'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/contracts',
    name: vueRoutes.contracts.name,
    components: {
      default: () => import('../Vue/components/Contracts/Contracts'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: '/contracts/sell',
    children: [
      {
        path: 'sell',
        name: vueRoutes.contractsSell.name,
        components: {
          default: () => import('../Vue/components/Contracts/Contracts'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'derivative',
        name: vueRoutes.contractsDerivative.name,
        components: {
          default: () => import('../Vue/components/Contracts/Contracts'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'overdraft',
        name: vueRoutes.contractsOverdraft.name,
        components: {
          default: () => import('../Vue/components/Contracts/Contracts'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'vesting',
        name: vueRoutes.contractsVesting.name,
        components: {
          default: () => import('../Vue/components/Contracts/Contracts'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  {
    // Top-level (not a /contracts child) because Contracts.vue - the parent
    // route's own component - has no nested <router-view>, so a child route
    // pointing at a different component (AffiliateContracts.vue) could never
    // actually render; Contracts.vue would stay mounted showing its own
    // empty state instead. Matches the existing /contracts/:id precedent
    // below. Must stay ordered before /contracts/:id, or :id would greedily
    // match the literal "affiliate" segment first.
    path: '/contracts/affiliate',
    name: vueRoutes.contractsAffiliate.name,
    components: {
      default: () => import('../Vue/components/Contracts/AffiliateContracts'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    path: '/contracts/:id',
    name: vueRoutes.contractsDetails.name,
    components: {
      default: () => import('../Vue/components/Contracts/ContractsDetails'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: '/contracts/:id/overdraft',
        name: vueRoutes.contractsDetailsOverdraft.name,
        components: {
          default: () => import('../Vue/components/Contracts/ContractsDetails'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: '/contracts/:id/vesting',
        name: vueRoutes.contractsDetailsVesting.name,
        components: {
          default: () => import('../Vue/components/Contracts/ContractsDetails'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  {
    path: '/dashboard',
    name: vueRoutes.dashboard.name,
    components: {
      default: () => import('@/Vue/components/Wallet/Dashboard.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: '/dashboard/operational-accounts',
    children: [
      {
        path: 'operational-accounts',
        name: vueRoutes.operationalAccounts.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'pooled-accounts',
        name: vueRoutes.pooledAccounts.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'exchange-rates',
        name: vueRoutes.exchangeRates.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'personal-wallet',
        name: vueRoutes.personalWallet.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  {
    path: '/wallet/',
    name: vueRoutes.wallet.name,
    components: {
      default: () => import('@/Vue/components/Wallet/Wallet.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: '/wallet/main-account',
    children: [
      {
        path: 'main-account',
        name: vueRoutes.mainAccount.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'token-re-account',
        name: vueRoutes.tokenReAccount.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'commission-account',
        name: vueRoutes.commissionAccount.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'profit-account',
        name: vueRoutes.profitAccount.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'tax-account',
        name: vueRoutes.taxAccount.name,
        components: {
          default: () =>
            import('../Vue/components/RealEstate/RealEstateTokens'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },
  {
    path: '/approvals',
    name: vueRoutes.approvals.name,
    components: {
      default: () => import('../Vue/components/Approvals/Approvals.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
    redirect: '/approvals/users',
    children: [
      {
        path: 'users',
        name: vueRoutes.approvalsUsers.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'notaries',
        name: vueRoutes.approvalsNotaries.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'edit',
        name: vueRoutes.approvalsEdit.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'tokenization',
        name: vueRoutes.approvalsTokenization.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'digital-twin',
        name: vueRoutes.approvalsDigitalTwin.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'offers',
        name: vueRoutes.approvalsOffers.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'commissioned',
        name: vueRoutes.approvalsCommissioned.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'withdrawal',
        name: vueRoutes.approvalsWithdrawal.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'overdraft',
        name: vueRoutes.approvalsOverdrafts.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'deposit',
        name: vueRoutes.approvalsDeposit.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'withdrawUSD',
        name: vueRoutes.approvalsWithdrawUSD.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'vesting',
        name: vueRoutes.approvalsVesting.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
      {
        path: 'address-moderation',
        name: vueRoutes.approvalsAddressModeration.name,
        components: {
          default: () => import('../Vue/components/Approvals/Approvals.vue'),
          SideBar,
        },
        meta: {
          requiredAuth: true,
        },
      },
    ],
  },

  {
    path: '/coordination',
    name: vueRoutes.coordination.name,
  },
  {
    path: '/dao',
    name: vueRoutes.daoAdmin.name,
    components: {
      default: () => import('@/Vue/components/DAO/DaoAdmin.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
  {
    // the exchange («БИРЖА»): overview, pairs and corridors, market maker, orders, limits, alerts…
    path: '/exchange-admin/:section?',
    name: vueRoutes.exchangeAdmin.name,
    components: {
      default: () => import('@/Vue/components/Exchange/ExchangeAdmin.vue'),
      SideBar,
    },
    meta: {
      requiredAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn'];
  // unable access for routes required login for unlogged users

  if (to.matched.some((record) => record.meta.requiredAuth)) {
    if (!isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  }
  // unable access for routes not required login (like login page) for logged in user
  else if (to.matched.some((record) => record.meta.requiredVisitor)) {
    if (isLoggedIn) {
      next('/users');
    } else {
      next();
    }
  }
});

export default router;
